import { useState, type FormEvent } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useLogin } from '../api/hooks'

export function Login() {
  const login = useLogin()
  const navigate = useNavigate()
  const location = useLocation()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const from = (location.state as { from?: string } | null)?.from

  function onSubmit(event: FormEvent) {
    event.preventDefault()
    login.mutate(
      { email, password },
      { onSuccess: () => navigate(from && from !== '/login' ? from : '/', { replace: true }) },
    )
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink-100 p-4">
      <div className="w-full max-w-sm rounded-lg border border-ink-200 bg-white p-6 shadow-sm">
        <div className="mb-5 flex items-baseline gap-1.5">
          <span className="text-lg font-bold tracking-tight text-ink-900">loco</span>
          <span className="text-2xs uppercase tracking-widest text-ink-600">translations</span>
        </div>
        <h1 className="text-sm font-semibold text-ink-900">Sign in</h1>
        <p className="mt-0.5 text-xs text-ink-600">
          tchop translation management — English source, German Sie and Du.
        </p>
        <form className="mt-4 space-y-3" onSubmit={onSubmit} noValidate>
          <div>
            <label className="label" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              className="field mt-1"
              type="email"
              autoComplete="username"
              required
              autoFocus
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div>
            <label className="label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              className="field mt-1"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          {login.isError && (
            <p role="alert" className="rounded border border-rose-300 bg-rose-50 px-2 py-1.5 text-xs text-rose-900">
              {(login.error as Error).message}
            </p>
          )}
          <button
            className="btn btn-primary w-full justify-center py-2"
            type="submit"
            disabled={login.isPending || !email || !password}
          >
            {login.isPending ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  )
}
